var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C9.31648 0 12 2.68376 12 6C12 9.31648 9.31624 12 6 12C2.68352 12 0 9.31624 0 6C0 2.68352 2.68378 0 6 0ZM6 11.0625C8.79827 11.0625 11.0625 8.79809 11.0625 6C11.0625 3.20173 8.79809 0.9375 6 0.9375C3.20173 0.9375 0.9375 3.20191 0.9375 6C0.9375 8.79827 3.20194 11.0625 6 11.0625Z",
    fill: "#192839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.02332C6.25889 5.02332 6.46875 5.23317 6.46875 5.49207V8.51065C6.46875 8.76954 6.25889 8.9794 6 8.9794C5.74111 8.9794 5.53125 8.76952 5.53125 8.51063V5.49207C5.53125 5.23317 5.74111 5.02332 6 5.02332Z",
    fill: "#192839"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.44922C5.65051 4.44922 5.36719 4.1659 5.36719 3.81641C5.36719 3.46691 5.65051 3.18359 6 3.18359C6.34949 3.18359 6.63281 3.46691 6.63281 3.81641C6.63281 4.1659 6.34949 4.44922 6 4.44922Z",
    fill: "#192839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.82c29fc3d0ecf8da9bce3988a7824da9.svg";
export { ForwardRef as ReactComponent };